/* Collections workstream (rebuild 2026-10): the dock card opens the PDP on the visitor's remembered Mac.
   No preselect unless localStorage "asc.mac" maps to one of the dock's allowed variants (the card lists
   them as id:SKU:TypeLetter, by SKU, never by title). Contract: asc.mac is a variant ID (nav.md, pdp.md); also tolerated: a SKU,
   a Type letter ("C".."F"), or JSON with one of variantId / variant / id / sku / type. Never overrides
   an explicit ?variant= in the link. */
(function () {
  function readMac() {
    var raw = null;
    try { raw = window.localStorage.getItem('asc.mac'); } catch (e) { return null; }
    if (!raw) return null;
    var v = raw;
    try { v = JSON.parse(raw); } catch (e) { /* plain string */ }
    if (v && typeof v === 'object') {
      return String(v.variantId || v.variant_id || v.variant || v.id || v.sku || v.type || '');
    }
    return String(v);
  }
  function apply() {
    var mac = readMac() || '';
    mac = mac.trim().toUpperCase().replace(/^TYPE\s*/, '');
    document.querySelectorAll('[data-asc-coll-dock]').forEach(function (a) {
      var src = a;
      if (a.dataset.ascCollFrom) src = document.getElementById(a.dataset.ascCollFrom) || a;
      var list = (src.dataset.ascCollVariants || '').split(',');
      var hit = null;
      list.forEach(function (row) {
        var p = row.trim().split(':');
        if (p.length < 3) return;
        if (mac && (mac === p[0] || mac === p[1].toUpperCase() || mac === p[2].toUpperCase())) hit = p[0];
      });
      if (!a.dataset.ascBase) a.dataset.ascBase = a.getAttribute('href');
      var url = new URL(a.dataset.ascBase, window.location.origin);
      if (url.searchParams.has('variant')) return;
      if (hit) url.searchParams.set('variant', hit);
      a.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  // Contract (nav.md / pdp.md): asc.mac is a variant ID written by the dock page; re-read when it changes.
  document.addEventListener('asc:mac:change', apply);
  window.addEventListener('storage', function (e) { if (e.key === 'asc.mac') apply(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) apply(); });
})();
